export default __webpack_public_path__ + "static/1-987f42e002f99bf50303eda8ca0c2932.png";